import { Checkbox, FormControl, FormControlLabel, FormHelperText, Grid, InputLabel, ListItemText, MenuItem, OutlinedInput, Select, TextField } from "@mui/material";
import { useEffect, useState } from "react";

const TypeOfSupportStep = ({ props }) => {
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, [])

    return (
        <Grid container spacing={2}>
            <Grid mt={'7.5px'} item xs={12}>
                <Grid item xs={12} container >
                    <Grid item>
                        {props.emptyFormProps.includes('support_timeframe') && <FormHelperText><b style={{ color: '#d32f2f' }}>This field is required</b></FormHelperText>}
                    </Grid>
                </Grid>
                <FormControl fullWidth size="small">
                    <InputLabel id="timeframe-select-label">Expected timeframe of SPICE support</InputLabel>
                    <Select
                        name="support_timeframe"
                        labelId="timeframe-select-label"
                        value={props.formData.support_timeframe}
                        onChange={props.handleInputChange}
                        input={<OutlinedInput label="Expected timeframe of SPICE support" />}
                    >
                        {props.supportTimeframeValues
                            .map((el) => (
                                <MenuItem key={el.id} value={el.value}>
                                    <ListItemText primary={el.value} />
                                </MenuItem>
                            ))}
                    </Select>
                </FormControl>
            </Grid>
            <Grid item xs={12}>
                <p>Preferred methods of support</p>
                <Grid item xs={12} container >
                    <Grid item>
                        {props.emptyFormProps.includes('method_of_support') && <FormHelperText><b style={{ color: '#d32f2f' }}>This field is required</b></FormHelperText>}
                    </Grid>
                </Grid>
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={props.selection === 'onlineOnly'}
                            onChange={() => props.handleCheckboxChange('onlineOnly')}
                        />
                    }
                    label="I prefer regular online support only"
                />
            </Grid>
            <Grid item xs={12}>
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={props.selection === 'onlineWithVisit'}
                            onChange={() => props.handleCheckboxChange('onlineWithVisit')}
                        />
                    }
                    label="I prefer regular online support with a short-term visit"
                />
            </Grid>

            {props.selection === 'onlineWithVisit' && (
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        label="Please provide a brief description of the preferred time of visit, and the activities the expert would perform"
                        multiline
                        minRows={3}
                        value={props.visitDescription}
                        onChange={(e) => props.handleVisitDescription(e.target.value)}
                    />
                </Grid>
            )}

            <Grid item xs={12}>
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={props.selection === 'shortTermVisit'}
                            onChange={() => props.handleCheckboxChange('shortTermVisit')}
                        />
                    }
                    label="I only prefer a short-term visit"
                />
            </Grid>

            {props.selection === 'shortTermVisit' && (
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        label="Please provide a brief description of the preferred time of visit, and the activities the expert would perform"
                        multiline
                        minRows={3}
                        value={props.visitDescription}
                        onChange={(e) => props.handleVisitDescription(e.target.value)}
                    />
                </Grid>
            )}
            {(props.selection === 'shortTermVisit' || props.selection === 'onlineWithVisit') && (
                <Grid item xs={12}>
                    <p>Financial responsibility</p>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={props.confirmSupport}
                                onChange={(e) => props.handleConfirmSupport(e.target.checked)}
                            />
                        }
                        label={
                            <span>
                                I confirm that I am able to support the expert in their in-country expenses. This includes providing appropriate, clean and safe accommodation, as well as three meals a day, or an appropriate daily subsistence allowance.
                                <br />
                                <br />
                                <strong>
                                    If you are unable to financially support the expert, please reach out to us at <a href="mailto:info@spice-global.org">info@spice-global.org</a> and we will get back to you as soon as possible.
                                </strong>
                            </span>
                        }
                    />
                </Grid>
            )}
        </Grid>
    );
}

export default TypeOfSupportStep;